<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="ri-layout-top-2-line me-1 font-20 text-primary"></i>
                                    Remunerations
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="fromDateTooltip"
                                        ngbTooltip="Filter by From date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" placeholder="From date..."
                                        autocomplete="off" [(ngModel)]="fromDate">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="toDateTooltip"
                                        ngbTooltip="Filter by To date." placement="top" container="body">
                                        <i class="bx bx-calendar-week"></i>
                                    </span>
                                    <input type="date" class="form-control border-start-0" placeholder="To date..."
                                        autocomplete="off" [(ngModel)]="toDate" [min]="fromDate">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        class=" btn btn-secondary btn-sm " style="font-size: 18px;"  (click)="onPaymentChange()">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="300">Payment Modes</th>
                                    <th scope="col" width="300">Date</th>
                                    <th scope="col" width="300" class="text-center">Remarks</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let payment of payments | search : 'name' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{payment.paymentMode}}</td>
                                    <td>{{payment.date| date:'MMM dd, yyyy'}}</td>
                                    <td class="text-center">{{payment.remarks || '-'}}</td>
                                    <td class="actions">
                                        <div *ngIf="payment?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        <i class="bx bx-receipt alert-primary" title="Salary Slip"
                                            (click)="processPayment(payment)"></i>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="5">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container *ngIf="payments && payments.length < 1; else noSearchResults">
                                            <td colspan="5">No remunerations were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="5"
                                                *ngIf="searchKeyword && (payments | search : 'name' : searchKeyword).length == 0">
                                                No remunerations were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>